export default __webpack_public_path__ + "static/media/2480.23e7932e.png";